import React, { useEffect, useRef, useState } from 'react';
import { FaAngleDown, FaChevronUp } from 'react-icons/fa';

const CategoryMenu = ({ list, onClick, activeFoodGroup,setExpanded,expanded,setCatInOneLine }) => {
  const [shouldShowToggle, setShouldShowToggle] = useState(false);
  const wrapperRef = useRef(null);
  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (wrapper) {
      const fullHeight = wrapper.scrollHeight;
       const visibleHeight = wrapper.clientHeight;
      const twoRowHeight = 100; 
      if (fullHeight > twoRowHeight) {
        setShouldShowToggle(true);
      }
      if (fullHeight <= visibleHeight) {
        setCatInOneLine(true);   
      } else {
        setCatInOneLine(false);  
      }
    }
  }, [list,expanded]);

  return (
    <div className={`menu-category-bar category-container`}>
      <div
        ref={wrapperRef}
        className={`category-list-wrapper ${expanded ? 'expanded' : 'collapsed'}`}
      >
        {list?.map((item) => (
          <div
            key={item?.id}
            className={`category-item ${activeFoodGroup === item?.id ? "active" : ""}`}
            onClick={() => onClick(item)}
          >
            {item?.name}
          </div>
        ))}
      </div>

      {shouldShowToggle && (
        <div className="dropdown-togglemenu" onClick={() => setExpanded(!expanded)}>
          {expanded ? <FaChevronUp /> : <FaAngleDown />}
        </div>
      )}
    </div>
  );
};

export default CategoryMenu;
